module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2026-4951bcb32abecd606c75027340b32e9a.svg";